/**
 * @typedef LINECommandOptions
 * @property {boolean} help
 * @property {boolean} version
 * @property {boolean} issue
 * @property {boolean} revoke
 */
